export type AffectedKeyKind =
  | 'ServicePointId'
  | 'ConnectionNumber'
  | 'PhoneNumber'
  | 'EmailAddress'
  | 'NetworkNodeName'
  | 'TechnicalServiceName'
  | 'CustomerNumber'

export type SearchType = 'FreeText' | 'EventId' | AffectedKeyKind

export const SEARCH_TYPE_LABELS: Record<SearchType, string> = {
  FreeText: 'Fritekst',
  EventId: 'Hendelse',
  ServicePointId: 'Lokasjon',
  ConnectionNumber: 'Samband',
  PhoneNumber: 'Telefon',
  EmailAddress: 'Epost',
  NetworkNodeName: 'Node',
  TechnicalServiceName: 'Tjeneste',
  CustomerNumber: 'Kunde',
}

export const SEARCH_TYPE_ORDER: SearchType[] = [
  'FreeText',
  'EventId',
  'CustomerNumber',
  'ServicePointId',
  'ConnectionNumber',
  'PhoneNumber',
  'EmailAddress',
  'NetworkNodeName',
  'TechnicalServiceName',
]

export const SEARCH_TYPE_PLACEHOLDERS: Record<SearchType, string> = {
  FreeText: 'Søk etter id, tittel, status, ansvarlig, berørt utstyr, ekst. referanse',
  EventId: 'Skriv inn hendelses-ID (eks. FF12345)',
  ServicePointId: 'Skriv inn leveransepunkt-ID',
  ConnectionNumber: 'Skriv inn sambandsnummer',
  PhoneNumber: 'Skriv inn telefonnummer',
  EmailAddress: 'Skriv inn epostadresse',
  NetworkNodeName: 'Skriv inn nodenavn',
  TechnicalServiceName: 'Skriv inn teknisk tjeneste (eks. TeliaOss-TV)',
  CustomerNumber: 'Skriv inn kundenummer eller -navn',
}

export function isSearchType(value: string | null | undefined): value is SearchType {
  return !!value && (SEARCH_TYPE_ORDER as string[]).includes(value)
}

export function isAffectedKeyKind(value: string | null | undefined): value is AffectedKeyKind {
  return isSearchType(value) && value !== 'FreeText' && value !== 'EventId'
}

// PhoneNumber and EmailAddress are deliberately excluded — the suggest endpoint is
// employee-only, but enumerating PII still violates data-minimisation.
export const SUGGESTABLE_KINDS: readonly AffectedKeyKind[] = ['NetworkNodeName', 'TechnicalServiceName', 'CustomerNumber']

export function isSuggestableKind(value: SearchType): value is AffectedKeyKind {
  return (SUGGESTABLE_KINDS as readonly string[]).includes(value)
}

export interface EntitySuggestion {
  value: string
  secondaryValue?: string | null
}

export function formatSuggestion(suggestion: EntitySuggestion): string {
  return suggestion.secondaryValue ? `${suggestion.value} — ${suggestion.secondaryValue}` : suggestion.value
}

// Customer autocomplete commits the formatted "12345 — Telia AS" string to the input field.
// At submit time we need the canonical number, so strip the trailing " — name" portion.
export function extractPrimaryValue(input: string): string {
  const dashIndex = input.indexOf(' — ')
  return dashIndex === -1 ? input.trim() : input.slice(0, dashIndex).trim()
}
